<template>
  <div>
    <vs-tabs v-model="currentTabIndex">
      <vs-tab v-for="(tab, tabIndex) in tabList" :key="`field_tab_${tab}`" :label="tab" @click="moveFieldTab(tabIndex, tab)" />
    </vs-tabs>

    <search-nav class="p-0" @handleSearch="onClickSearch">
      <search-year-range
        label="연도"
        v-model="nav.yearRange"
        :options="{
          yearsBack: 0,
        }"
      />
      <search-keyword label="팀명" v-model="nav.teamName" />
    </search-nav>

    <div class="flex items-center justify-between mb-4 gap-4">
      <div class="summary-line">
        <template v-if="currentTabIndex === 0">
          <span class="summary-item"><b>총 등록건수:</b> {{ totalCount }}건</span>
          <span v-for="fieldName in fieldList" :key="`sum_${fieldName}`" class="summary-item">
            <b>{{ fieldName }}:</b> {{ fieldCounts[fieldName] || 0 }}건
          </span>
          <span class="summary-item"><b>개선전:</b> {{ beforeCount }}건</span>
          <span class="summary-item"><b>개선완료:</b> {{ improvedCount }}건</span>
          <span class="summary-item"><b>진행률:</b> {{ progressRate }}%</span>
        </template>
        <template v-else>
          <span class="summary-item"
            ><b>{{ currentField }} 등록건수:</b> {{ totalCount }}건</span
          >
          <span class="summary-item"><b>개선전:</b> {{ beforeCount }}건</span>
          <span class="summary-item"><b>개선완료:</b> {{ improvedCount }}건</span>
          <span class="summary-item"><b>진행률:</b> {{ progressRate }}%</span>
        </template>
      </div>
      <vs-button color="secondary" type="border" @click="onClickExcelDownload">Excel 다운로드</vs-button>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full" style="min-width: 1598px">
        <colgroup>
          <col width="63px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="96px" />
          <col width="96px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
        </colgroup>
        <thead>
          <tr>
            <th colspan="14" class="text-left">
              <span>환경영향평가서 완료된 사항 중 중요환경영향에 해당되는 ‘M’ 등급 이상 :</span>
              <span>{{ list.length }}건</span>
            </th>
          </tr>
          <tr>
            <th rowspan="2" class="table-cell">No.</th>
            <th rowspan="2" class="table-cell">개선상태</th>
            <th rowspan="2" class="table-cell">사업장명</th>
            <th rowspan="2" class="table-cell">팀명</th>
            <th rowspan="2" class="table-cell">공장명</th>
            <th rowspan="2" class="table-cell">공정명</th>
            <th rowspan="2" class="table-cell">상태</th>
            <th rowspan="2" class="table-cell">활동명</th>
            <th colspan="2" class="table-cell">등급</th>
            <th rowspan="2" class="table-cell">담당자</th>
            <th rowspan="2" class="table-cell">개선방안</th>
            <th rowspan="2" class="table-cell">개선결과</th>
            <th rowspan="2" class="table-cell">비고</th>
          </tr>
          <tr>
            <th>개선 전</th>
            <th>개선 후</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="list.length === 0">
            <td colspan="14" class="text-center py-8 text-gray-500">
              <feather-icon icon="InboxIcon" class="inline-block mb-2" style="width: 40px; height: 40px" />
              <div>데이터가 없습니다.</div>
            </td>
          </tr>
          <template v-else>
            <tr v-for="(row, rowIndex) in list" :key="`row_${row.post_id}_${row.dataCode}`">
              <!-- No. -->
              <td>{{ rowIndex + 1 }}</td>
              <!-- 상태-->
              <td>
                <span v-if="row.개선상태 === '개선완료'" class="text-success">개선 완료</span>
                <span v-else class="text-danger">개선 전</span>
              </td>
              <!-- 사업장명 -->
              <td>{{ row.사업장명 }}</td>
              <!-- 팀명 -->
              <td>{{ row.팀명 }}</td>
              <!-- 공장명 -->
              <td>{{ row.공장명 }}</td>
              <!-- 공정명 -->
              <td>{{ row.공정명 }}</td>
              <!-- 상태 -->
              <td>{{ row.상태 }}</td>
              <!-- 활동명 -->
              <td>{{ row.활동명 }}</td>
              <!-- 등급 / 개선 전 -->
              <td>
                <h5 class="mb-2" :style="{ color: row.등급_개선전.color }">{{ row.등급_개선전.name }}</h5>
                <vs-button class="px-2 py-1" color="#7E72F2" style="text-wrap: nowrap" @click="onClickDetailPost(row, 'first')">원문보기</vs-button>
              </td>
              <!-- 등급 / 개선 후 -->
              <td>
                <h5 class="mb-2" :style="{ color: row.등급_개선후 ? row.등급_개선후.color : undefined }">{{ row.등급_개선후 ? row.등급_개선후.name : "-" }}</h5>
                <vs-button v-if="row.등급_개선후" class="px-2 py-1" color="#7E72F2" style="text-wrap: nowrap" @click="onClickDetailPost(row, 'last')">원문보기</vs-button>
              </td>
              <!-- 담당자 -->
              <td>{{ row.담당자 }}</td>
              <!-- 개선방안 -->
              <td>
                <div class="flex gap-2 flex-wrap justify-center">
                  <vs-button v-if="row.개선상태 !== '개선완료' || !(row.raw.planResult && row.raw.planResult['개선방안'])" class="px-2 py-1" color="#7E72F2" style="text-wrap: nowrap" @click="onClickPost(row, '개선방안', false)"
                    >작성/수정</vs-button
                  >
                  <vs-button v-if="row.raw.planResult && row.raw.planResult['개선방안']" class="px-2 py-1" type="border" color="#7E72F2" style="text-wrap: nowrap" @click="onClickPost(row, '개선방안', true)">보기</vs-button>
                  <p v-else>미작성</p>
                </div>
              </td>
              <!-- 개선결과 -->
              <td>
                <div class="flex gap-2 flex-wrap justify-center">
                  <vs-button v-if="row.개선상태 !== '개선완료' || !(row.raw.planResult && row.raw.planResult['개선결과'])" class="px-2 py-1" color="#7E72F2" style="text-wrap: nowrap" @click="onClickPost(row, '개선결과', false)"
                    >작성/수정</vs-button
                  >
                  <vs-button v-if="row.raw.planResult && row.raw.planResult['개선결과']" class="px-2 py-1" type="border" color="#7E72F2" style="text-wrap: nowrap" @click="onClickPost(row, '개선결과', true)">보기</vs-button>
                  <p v-else>미작성</p>
                </div>
              </td>
              <!-- 비고 -->
              <td>
                <vs-button v-if="row.개선상태 === '개선완료'" class="px-2 py-1" color="#3C3C3C">종결</vs-button>
                <vs-button v-else class="px-2 py-1" color="#FF9F43" @click="onClickResend(row)">개정</vs-button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <popup-post-viewer v-model="postViewer" v-bind="propsPostViewer">
      <template #foot="{ close }">
        <div class="p-3 flex justify-between border-top">
          <div class="flex ml-auto">
            <vs-button class="mr-2" color="#DCDFE2" style="color: #3c3c3c" @click="close">취소</vs-button>
            <vs-button v-if="propsPostViewer.개선상태 === '개선완료'" color="#3C3C3C">종결</vs-button>
            <vs-button v-else color="#7E72F2" @click="onClickResend(propsPostViewer.row)">개정</vs-button>
          </div>
        </div>
      </template>
    </popup-post-viewer>

    <popup-reformation-plan v-model="reformationPlan" v-bind="propsReformationPlanResult" @save="saveReformationPlanResult" />
    <popup-reformation-result v-model="reformationResult" v-bind="propsReformationPlanResult" @save="saveReformationPlanResult" />

    <popup-excel-download title="중요환경영향 등록부" v-model="showExcelPopup" :list="excelList" />
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import PopupPostViewer from "@/popup/PopupPostViewer.vue";
import PopupReformationPlan from "@/views/boards/single-page/900/PopupReformationPlan.vue";
import PopupReformationResult from "@/views/boards/single-page/900/PopupReformationResult.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";
import SearchYearRange from "@/views/list/components/SearchYearRange.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";

export default {
  name: "Page",
  components: {
    SearchKeyword,
    SearchYearRange,
    PopupExcelDownload,
    PopupReformationResult,
    PopupReformationPlan,
    PopupPostViewer,
    SearchNav,
  },

  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    fieldList() {
      return this.tabList.slice(1);
    },
    currentField() {
      return this.tabList[this.currentTabIndex] || "";
    },
    totalCount() {
      return this.list.length;
    },
    fieldCounts() {
      const counts = {};
      for (const fieldName of this.fieldList) {
        counts[fieldName] = 0;
      }
      for (const row of this.list) {
        const name = row && row.사업장명;
        if (!name) continue;
        if (counts[name] === undefined) {
          counts[name] = 0;
        }
        counts[name]++;
      }
      return counts;
    },
    improvedCount() {
      return this.list.filter((r) => r && r.개선상태 === "개선완료").length;
    },
    beforeCount() {
      return this.list.filter((r) => r && r.개선상태 === "개선전").length;
    },
    progressRate() {
      if (this.totalCount === 0) return "0.0";
      const rate = (this.improvedCount / this.totalCount) * 100;
      return rate.toFixed(1);
    },
  },
  data() {
    return {
      currentTabIndex: 0,
      tabList: ["전사", "본사", "인천공장", "당진공장", "포항공장", "중앙기술연구소"],

      nav: {
        yearRange: { start: new Date().getFullYear() - 2, end: new Date().getFullYear() },
        fieldName: "",
        teamName: "",
      },
      list: [],
      postViewer: false,
      propsPostViewer: { title: "" },

      reformationPlan: false,
      reformationResult: false,
      propsReformationPlanResult: { dataCode: "", postId: 0, data: undefined, readonly: false },

      showExcelPopup: false,
      excelList: [],
    };
  },

  created() {
    this.fixDataCodes().then(() => this.loadList());
  },

  methods: {
    moveFieldTab() {
      this.loadList();
    },
    onClickSearch() {
      this.loadList();
    },

    async loadList() {
      const perPage = 50;

      let list = [];
      this.loading(true);
      list.push(...(await this.loadList899(perPage)));

      // 중요도 점수에 따른 등급이 M 이상인 데이터만 필터링
      const originMData = [];
      if (list.length > 0) {
        for (const item of list) {
          const postId = item.post_id;
          const parentId = item.post_parent_id;
          const body = this.getItemBody(item);
          const point = body.환경영향평가 && body.환경영향평가.중요도_점수;

          if (!parentId && point >= 15 && item.document_status_id !== 1) {
            originMData.push(postId);
          }
        }
      }

      // M 등급 원본의 개정 문서를 연도 무관하게 추가 로드 (연도가 달라 범위 밖에 있는 개정 문서 처리)
      if (originMData.length > 0) {
        const currentPostIds = new Set(list.map((item) => item.post_id));
        const revisions = await this.loadRevisionsByParentIds(originMData);
        for (const r of revisions) {
          if (!currentPostIds.has(r.post_id)) list.push(r);
        }
      }

      // 부모데이터의 중요도 점수가 M 이상인 데이터만 필터링 (부모가 없을 경우 본인 데이터로 필터링)
      list = list.filter((item) => {
        const postId = item.post_id;
        const parentId = item.post_parent_id;
        return originMData.includes(parentId || postId);
      });

      // parentId (없을 경우 boardId) 를 기준으로 데이터 그룹화
      const group = list.reduce((acc, cur) => {
        const parentId = cur.post_parent_id || cur.post_id;
        if (!acc[parentId]) acc[parentId] = [];
        acc[parentId].push(cur);
        return acc;
      }, {});

      const groupKey = Object.keys(group);

      // 개선방안, 개선결과 리스트 불러오기
      const planResults = await this.loadPlanResultList(groupKey);
      // 그룹화된 데이터를 통해 Table 에 표기 할 수 있도록 리스트 생성
      list = groupKey.map((key) => {
        const items = group[key];
        const first = items.find((item) => !item.post_parent_id) || items[0];
        const firstBody = this.getItemBody(first);
        const last = this.getLastRevision(items);
        const lastBody = this.getItemBody(last);
        const temp = items.filter((item) => {
          return item.document_status_id === 1;
        });
        const post = {
          raw: { first, last, temp: temp.length > 0 ? temp[0] : null, planResult: planResults[`${key}_1`] },
          post_id: key,
          dataCode: `${key}_1`,
          개선상태: last.post_parent_id ? "개선완료" : "개선전",
          사업장명: firstBody.stdInfo && firstBody.stdInfo.field_name,
          팀명: firstBody.공정분류 && firstBody.공정분류.팀명,
          공장명: firstBody.공정분류 && firstBody.공정분류.공장명,
          공정명: firstBody.공정분류 && firstBody.공정분류.공정명,
          상태: firstBody.공정분류 && firstBody.공정분류.상태,
          활동명: firstBody.공정분류 && firstBody.공정분류.활동명,
          담당자: (firstBody.평가정보 && firstBody.평가정보.담당자) || (firstBody.stdInfo && firstBody.stdInfo.writer_name),
          중요도점수: firstBody.환경영향평가 && firstBody.환경영향평가.중요도_점수,
          등급_개선전: this.getRating(firstBody.환경영향평가 && firstBody.환경영향평가.중요도_점수),
          등급_개선후: first.post_id !== last.post_id ? this.getRating(lastBody.환경영향평가 && lastBody.환경영향평가.중요도_점수) : "",
        };
        return post;
      });

      // [DEBUG] 개선방안/개선결과가 "미작성"으로 표시되는 행 출력
      const unlinkedRows = list.filter((row) => {
        const hasPlan = row.raw.planResult && row.raw.planResult["개선방안"];
        const hasResult = row.raw.planResult && row.raw.planResult["개선결과"];
        return !hasPlan || !hasResult;
      });
      if (unlinkedRows.length > 0) {
        console.group("[DEBUG] 미작성(연결 안됨) 행 목록 - " + unlinkedRows.length + "건");
        for (const row of unlinkedRows) {
          const hasPlan = row.raw.planResult && row.raw.planResult["개선방안"];
          const hasResult = row.raw.planResult && row.raw.planResult["개선결과"];
          console.group("post_id:", row.post_id, "| 팀명:", row.팀명, "| 활동명:", row.활동명);
          console.log("  dataCode (연결 키):", row.dataCode);
          console.log("  planResult:", row.raw.planResult ? "있음 (board900 postId: " + row.raw.planResult.id + ")" : "없음 (board 900 문서 미발견)");
          if (!hasPlan) console.warn("  개선방안: 미작성");
          if (!hasResult) console.warn("  개선결과: 미작성");
          console.log("  → DB에서 확인할 것: board_id=900, body.dataCode =", "'" + row.dataCode + "'");
          console.log("  → Board 899 원문 post_id:", row.raw.first && row.raw.first.post_id);
          console.groupEnd();
        }
        console.groupEnd();
      } else {
        console.log("[DEBUG] 미작성 행 없음 - 모든 행 연결 정상");
      }

      this.list = list;
      this.loading(false);
    },

    getItemBody(item) {
      if (item.postContents && item.postContents.body) return item.postContents.body;
      try {
        const parsed = JSON.parse(item.post_content || "{}");
        return parsed.body || {};
      } catch {
        return {};
      }
    },

    getLastRevision(items) {
      if (items.length === 0) return undefined;
      const nonDrafts = items.filter((item) => item.document_status_id !== 1);
      const pool = nonDrafts.length > 0 ? nonDrafts : items;
      return pool.reduce((latest, item) => (item.post_id > latest.post_id ? item : latest));
    },

    async loadList899(perPage) {
      const search = this.nav;
      const projectId = this.projectId;
      const page = 1;
      const boardId = 899;
      const statusIds = [1, 4];
      const conditions = [];

      // 검색연도 (범위)
      const yr = search.yearRange;
      if (yr && yr.start) {
        conditions.push({ key: "created_at", operator: ">=", value: `${yr.start}-01-01` });
      }
      if (yr && yr.end) {
        conditions.push({ key: "created_at", operator: "<", value: `${Number(yr.end) + 1}-01-01` });
      }

      // 사업장명
      if (this.currentTabIndex > 0) {
        conditions.push({ key: "body.stdInfo.field_name", operator: "LIKE", value: `%${this.tabList[this.currentTabIndex]}%` });
      }

      // 팀명
      if (search.teamName) {
        conditions.push({ key: "body.공정분류.팀명", operator: "LIKE", value: `%${search.teamName}%` });
      }

      const metaKeys = [
        "created_at",
        "body.stdInfo.field_name",
        "body.stdInfo.writer_name",
        "body.공정분류.팀명",
        "body.공정분류.공장명",
        "body.공정분류.공정명",
        "body.공정분류.상태",
        "body.공정분류.활동명",
        "body.평가정보.담당자",
        "body.환경영향평가.중요도_점수",
      ];

      const options = {
        projectId,
        boardSlug: `board-${boardId}`,
        page,
        perPage,
        conditions,
        withMeta: true,
        withoutRelation: true,
        onlyMeta: true,
        metaKeys,
        statusIds,
      };
      return await this._loadDefragmentation(options);
    },

    // M 등급 원본의 개정 문서를 연도 무관하게 로드
    async loadRevisionsByParentIds(parentIds) {
      if (!parentIds || parentIds.length === 0) return [];
      const projectId = this.projectId;
      const metaKeys = [
        "created_at",
        "body.stdInfo.field_name",
        "body.stdInfo.writer_name",
        "body.공정분류.팀명",
        "body.공정분류.공장명",
        "body.공정분류.공정명",
        "body.공정분류.상태",
        "body.공정분류.활동명",
        "body.평가정보.담당자",
        "body.환경영향평가.중요도_점수",
      ];
      const options = {
        projectId,
        boardSlug: `board-899`,
        page: 1,
        perPage: 100,
        statusIds: [1, 4],
        conditions: [{ key: "post_parent_id", operator: "IN", value: parentIds }],
        withMeta: true,
        withoutRelation: true,
        onlyMeta: true,
        metaKeys,
      };
      return await this._loadDefragmentation(options);
    },

    // 개선방안, 개선결과 리스트
    async loadPlanResultList(groupKey) {
      const projectId = this.projectId;
      const boardId = 900;
      const page = 1;
      const perPage = 100;
      const conditions = [{ key: "body.dataCode", operator: "IN", value: groupKey.map((v) => `${v}_1`) }];

      const options = {
        projectId,
        boardId,
        page,
        perPage,
        //conditions,
      };
      const data = {};
      const list = await this._loadDefragmentation(options, "board/LOAD_POST_LIST");

      // [DEBUG] board 900에서 로드된 전체 dataCode 목록 출력
      console.group("[DEBUG] Board 900 로드된 개선방안/결과 목록");
      console.log("총", list.length, "건 로드됨");
      const loadedDataCodes = [];
      for (const post of list) {
        let body = null;
        try {
          body = JSON.parse(post.post_content).body;
        } catch (e) {
          console.warn("  [파싱오류] postId:", post.id, e);
          continue;
        }
        loadedDataCodes.push(body.dataCode);
        console.log("  postId:", post.id, "| dataCode:", body.dataCode, "| 개선방안:", body["개선방안"] ? "작성됨" : "없음", "| 개선결과:", body["개선결과"] ? "작성됨" : "없음");
        data[body.dataCode] = {
          id: post.id,
          ...body,
        };
      }
      console.log(
        "기대했던 dataCode 목록:",
        groupKey.map((v) => `${v}_1`)
      );
      const expectedCodes = groupKey.map((v) => `${v}_1`);
      const missingCodes = expectedCodes.filter((code) => loadedDataCodes.indexOf(code) === -1);
      if (missingCodes.length > 0) {
        console.warn("  [누락] board 900에서 찾을 수 없는 dataCode:", missingCodes);
      }
      console.groupEnd();

      return data;
    },

    // options.page 에 설정된 페이지부터 마지막 페이지까지 데이터를 불러옴
    async _loadDefragmentation(options, dispatch = "approval/LOAD_POST_ALL") {
      const response = await this.$store.dispatch(dispatch, options);
      const list = [];
      list.push(...response.data);
      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        list.push(...(await this._loadDefragmentation(options, dispatch)));
      }
      return list;
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    async onClickResend(row) {
      const raw = row.raw.last;
      const projectId = raw.project_id;
      const boardId = raw.board_id;
      let content = null;

      if (raw.post_content && typeof raw.post_content === "string" && raw.post_content.length > 0) {
        try {
          content = JSON.parse(raw.post_content);
        } catch (e) {
          content = null;
        }
      }

      if (!content && raw.post_id) {
        this.loading(true);
        try {
          const response = await this.$store.dispatch("approval/LOAD_POST", {
            boardSlug: `board-${boardId}`,
            postId: raw.post_id,
          });
          if (response.post && response.post.post_content) {
            content = JSON.parse(response.post.post_content);
          }
        } catch (e) {
          alert("문서를 불러오는 중 오류가 발생했습니다.");
          return;
        } finally {
          this.loading(false);
        }
      }

      if (!content || !content.body) {
        alert("문서 내용을 불러올 수 없습니다.");
        return;
      }

      const parentId = raw.post_parent_id || raw.post_id;
      let postId = row.raw.temp ? row.raw.temp.post_id : 0;

      if (!postId) {
        if (confirm("개정 할 경우\n기존 문서는 유지되고, 내용이 복사되어 임시저장 됩니다.\n개정 하시겠습니까?")) {
          postId = await this.resend(projectId, boardId, parentId, content);
        }
      }

      if (postId) {
        this.$router.push(`/project/${projectId}/tab/${boardId}/write/${postId}?_t_back=900/page`);
      }
    },

    // 개정
    async resend(projectId, boardId, parentId, form) {
      const boardSlug = `board-${boardId}`;
      const title = "환경영향평가서";
      const approvalLine = []; // 개정시 결재라인 초기화

      form.body.평가정보.평가일 = new Date().format("yyyy-MM-dd");

      let postId = 0;
      await this.$store
        .dispatch("approval/CREATE_POST", {
          isTemp: 1,
          boardSlug,
          projectId,
          title,
          parentId,
          content: JSON.stringify(form),
          approvalLine: JSON.stringify(approvalLine),
          security: "normal",
          priority: "medium",
        })
        .then((response) => {
          postId = response.postId;
        });

      return postId;
    },

    async onClickPost(row, type, readonly) {
      this.propsReformationPlanResult.postId = row.raw.planResult ? row.raw.planResult.id : 0;
      this.propsReformationPlanResult.dataCode = row.dataCode;
      this.propsReformationPlanResult.readonly = readonly;
      this.propsReformationPlanResult.data = row.raw.planResult;

      if (type === "개선방안") {
        this.reformationPlan = true;
      } else if (type === "개선결과") {
        this.reformationResult = true;
      }
    },

    async onClickDetailPost(row, revision) {
      const raw = row.raw[revision];
      const boardId = raw.board_id;
      const postId = raw.post_id;
      let content = null;

      if (raw.post_content && typeof raw.post_content === "string" && raw.post_content.length > 0) {
        try {
          content = JSON.parse(raw.post_content);
        } catch (e) {
          content = null;
        }
      }

      if (!content && postId) {
        this.loading(true);
        try {
          const response = await this.$store.dispatch("approval/LOAD_POST", {
            boardSlug: `board-${boardId}`,
            postId,
          });
          if (response.post && response.post.post_content) {
            content = JSON.parse(response.post.post_content);
          }
        } catch (e) {
          alert("문서를 불러오는 중 오류가 발생했습니다.");
          return;
        } finally {
          this.loading(false);
        }
      }

      if (!content || !content.body) {
        alert("문서 내용을 불러올 수 없습니다.");
        return;
      }

      this.propsPostViewer.boardId = boardId;
      this.propsPostViewer.body = {};
      this.propsPostViewer.row = row;
      this.propsPostViewer.개선상태 = row.개선상태;
      if (boardId === 899) this.propsPostViewer.title = "환경영향평가서";
      this.propsPostViewer.body = content.body;
      this.$nextTick(() => {
        this.postViewer = true;
      });
    },

    onClickExcelDownload() {
      this.excelList = this.list.map((value, index) => {
        return {
          "No.": index + 1,
          개선상태: value.개선상태,
          사업장명: value.사업장명,
          팀명: value.팀명,
          공장명: value.공장명,
          공정명: value.공정명,
          상태: value.상태,
          활동명: value.활동명,
          등급_개선전: value.등급_개선전.name,
          등급_개선후: value.등급_개선후 ? value.등급_개선후.name : "-",
          담당자: value.담당자,
        };
      });

      this.showExcelPopup = true;
    },

    getRating(point) {
      if (point >= 25) return { name: "H", color: "#E42728" };
      else if (point >= 15) return { name: "M", color: "#EA5455" };
      else if (point >= 5) return { name: "L", color: "#FF9F43" };
      else return { name: "N", color: "#28C76F" };
    },

    async saveReformationPlanResult(postId, form) {
      const projectId = this.projectId;
      const boardId = 900;
      const title = "중요환경영향 등록부 / 개선방안 및 결과";
      const content = JSON.stringify({
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          date: new Date().format("yyyy-MM-dd"),
          half: new Date().getMonth() + 1 <= 6 ? "상반기" : "하반기", //반기
        },
        body: form,
      });

      if (postId && postId > 0) {
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      } else {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      }

      await this.loadList();
    },

    async fixDataCodes() {
      const projectId = this.projectId;
      const boardId = 900;
      const fixes = [
        { postId: 64796, oldCode: "50994_1", newCode: "19723_1" },
        { postId: 64797, oldCode: "59569_1", newCode: "22332_1" },
        { postId: 55145, oldCode: "60090_1", newCode: "22371_1" },
      ];

      const result = await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page: 1,
        perPage: 10,
        postIds: fixes.map((f) => f.postId),
      });

      const posts = result.data || [];
      for (const post of posts) {
        const fix = fixes.find((f) => f.postId === post.id);
        if (!fix) continue;

        const content = JSON.parse(post.post_content);
        if (content.body.dataCode !== fix.oldCode) {
          console.log(`[Fix] postId ${fix.postId}: 이미 수정됨 (${content.body.dataCode})`);
          continue;
        }

        content.body.dataCode = fix.newCode;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId: post.id,
          title: post.post_title || "중요환경영향 등록부 / 개선방안 및 결과",
          content: JSON.stringify(content),
        });
        console.log(`[Fix] postId ${fix.postId}: ${fix.oldCode} → ${fix.newCode} 완료`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 0.5rem;
    text-align: center;
  }
  th {
    background-color: #f9f9f9;
    padding: 1rem 0.75rem;
    font-size: 1rem;
    font-weight: bold;
    color: #3c3c3c;
  }
  td {
    background-color: #fff;
  }
}

.text-danger,
.text-success {
  font-size: 1rem;
  font-weight: bold;
}

.summary-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #3c3c3c;
}
.summary-line .summary-item {
  white-space: nowrap;
}
.summary-line .summary-item b {
  margin-right: 4px;
}
</style>
